const accessLevel = {
  Gestor: 100,
  Secretário: 80,
  Professor: 10,
} as const;

export function TranslateAccessLevel(accessLevelString: number | string) {
  for (const key in accessLevel) {
    if (accessLevel[key as keyof typeof accessLevel] === accessLevelString) {
      return key as keyof typeof accessLevel;
    }
  }
  return "Professor";
}
